import { render, staticRenderFns } from "./UnderlyingConditionsSection.vue?vue&type=template&id=fb90a7d2&scoped=true&lang=pug&"
import script from "./UnderlyingConditionsSection.vue?vue&type=script&lang=js&"
export * from "./UnderlyingConditionsSection.vue?vue&type=script&lang=js&"
import style0 from "./UnderlyingConditionsSection.vue?vue&type=style&index=0&id=fb90a7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb90a7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VSimpleTable,VTextField})
